var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaystack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.174 3H3.93233C3.4459 3 3 3.44595 3 3.97297V5.67568C3 6.2027 3.4459 6.64865 3.93233 6.64865H19.174C19.701 6.64865 20.1063 6.2027 20.1469 5.67568V3.97297C20.1469 3.44595 19.701 3 19.174 3ZM19.174 12.5676H3.93233C3.68912 12.5676 3.4459 12.6892 3.24322 12.8514C3.08107 13.0135 3 13.2568 3 13.5405V15.2432C3 15.7703 3.4459 16.2162 3.93233 16.2162H19.174C19.701 16.2162 20.1063 15.8108 20.1469 15.2432V13.5405C20.1469 12.973 19.701 12.5676 19.174 12.5676ZM12.526 17.3514H3.93233C3.68912 17.3514 3.4459 17.4324 3.28375 17.6351C3.12161 17.7973 3 18.0405 3 18.3243V20.027C3 20.5541 3.4459 21 3.93233 21H12.4855C13.0125 21 13.4178 20.5541 13.4178 20.027V18.2838C13.4584 17.7568 13.053 17.3514 12.526 17.3514ZM20.1469 7.78378H3.93233C3.68912 7.78378 3.4459 7.86486 3.28375 8.06757C3.12161 8.22973 3 8.47297 3 8.75676V10.4595C3 10.9865 3.4459 11.4324 3.93233 11.4324H20.1063C20.6333 11.4324 21.0387 10.9865 21.0387 10.4595V8.75676C21.0792 8.22973 20.6738 7.78378 20.1469 7.78378Z",
    fill: "#00C3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.4f7359a4f5340e7c0c493b7c53ae9be6.svg";
export { ForwardRef as ReactComponent };